export const PipEvent = {
  PipModeToggleClick: 'pip_mode_toggle_click',
  PipModeEnabled: 'pip_mode_enabled',
  PipModeExit: 'pip_mode_exit',
} as const;

export interface PipEventDataType {
  [PipEvent.PipModeToggleClick]: {
    action: 'turn_on' | 'turn_off';
    event_location: string;
  };
  [PipEvent.PipModeEnabled]: {
    symbol: string;
  };
  [PipEvent.PipModeExit]: {
    symbol: string;
    pip_enabled_ts: string;
  };
}
